import flatten from 'lodash.flatten';
import { REQUIRED_DATE_TIME_PROPERTIES, AUDIT_PROPERTIES, UPDATED, STATUS } from '../../constants';

const getDataProperties = (schema, additionalPropsInput) => {
  const additionalProps = Array.isArray(additionalPropsInput) ? additionalPropsInput : [];
  const { relations = [], properties = {}, dynamicProperties = {} } = schema;

  const relationProperties = flatten(
    relations
      .filter(({ showInForm, foreignKey }) => showInForm && properties[foreignKey])
      .map(({ foreignKey, entityIdentifierKey }) =>
        entityIdentifierKey ? [foreignKey, entityIdentifierKey] : foreignKey
      )
  );

  const statusProperty = properties.status ? STATUS : '';
  const dateTimeProperties = getDateTimeProperties(dynamicProperties);
  const auditProperties = getAuditProperties(dynamicProperties);
  const showInFormProperties = getProperties(properties);

  return [
    ...showInFormProperties,
    ...relationProperties,
    ...dateTimeProperties,
    ...auditProperties,
    ...additionalProps,
    statusProperty,
    UPDATED
  ].filter(Boolean);
};

function getDateTimeProperties(dynamicProperties) {
  return REQUIRED_DATE_TIME_PROPERTIES.filter(prop => dynamicProperties[prop]);
}

function getAuditProperties(dynamicProperties) {
  return AUDIT_PROPERTIES.filter(prop => dynamicProperties[prop]);
}

function getProperties(schemaProperties) {
  const graphqlProperties = [];
  Object.entries(schemaProperties).forEach(([propertyName, propertySchema]) => {
    const { type, showInForm = false, properties, items } = propertySchema;
    if (!showInForm) return;

    let propertyString = propertyName;
    if (type === 'object') {
      propertyString = handleNestedProperties(properties, propertyName);
    } else if (type === 'array' && items && items.properties) {
      propertyString = handleNestedProperties(items.properties, propertyName);
    }

    if (propertyString) graphqlProperties.push(propertyString);
  });
  return graphqlProperties;
}

function handleNestedProperties(properties, propertyName) {
  const nestedProps = getProperties(properties);
  if (!nestedProps.length) return null;
  return `${propertyName} { ${nestedProps.join(', ')} }`;
}

export default getDataProperties;
